import React, { useMemo } from 'react';
import objectPath from 'object-path';
// LayoutContext
import { useHtmlClassService } from '../../_metronic/layout/_core/MetronicLayout';
// Import Layout components
import { Header } from './header/Header';
import { HeaderMobile } from '../../_metronic/layout/components/header-mobile/HeaderMobile';
// import { Footer } from './footer/Footer';
import { LayoutInit } from '../../_metronic/layout/components/LayoutInit';
import { QuickPanel } from '../../_metronic/layout/components/extras/offcanvas/QuickPanel';
import { QuickUser } from '../../_metronic/layout/components/extras/offcanvas/QuickUser';
import { ScrollTop } from '../../_metronic/layout/components/extras/ScrollTop';
// import { StickyToolbar } from '../../_metronic/layout/components/extras/StickyToolbar';
import { SubHeader } from './subheader/SubHeader';
import { Aside } from './aside/Aside';
import { HelpSidebar } from './HelpSidebar';
import SuperAdminStats from '../../_metronic/layout/components/extras/offcanvas/SuperAdminStats';
import { useRecoilValueLoadable } from 'recoil';
import { user } from '../../recoil/atoms/user';

export function Layout({ classes, children }) {
  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, 'self.layout'),
      asideDisplay: objectPath.get(uiService.config, 'aside.self.display'),
      subheaderDisplay: objectPath.get(uiService.config, 'subheader.display'),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        'header.self.fixed.desktop'
      ),
      contentCssClasses: uiService.getClasses('content', true),
      contentContainerClasses: uiService.getClasses('content_container', true),
      contentExtended: objectPath.get(uiService.config, 'content.extended'),
    };
  }, [uiService]);
  const userAtom = useRecoilValueLoadable(user);
  const loginUser = userAtom.contents?.user ?? {};
  const ignorePadding =
    window.location.pathname === '/manage/powerlists/view-disposition-rules';

  return layoutProps.selfLayout !== 'blank' ? (
    <>
      {loginUser.role === 'superadmin' && (
        <>
          <div className="header bid-stats superStyle">
            <SuperAdminStats userAtom={userAtom} classes={classes} />
          </div>
        </>
      )}
      {/* begin::Main */}
      <HeaderMobile />
      <div className={`d-flex flex-column flex-root ${classes.root}`}>
        {/* begin::Page */}
        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && <Aside />}
          {/* begin::Wrapper */}
          <div
            // style={{ paddingTop: ignorePadding ? '167px !important' : '173px' }}
            className={`d-flex flex-column flex-row-fluid wrapper`}
            id="kt_wrapper"
          >
            <Header />
            {/* begin::Content */}
            <div
              id="kt_content"
              className={`content ${
                layoutProps.contentCssClasses
              } d-flex flex-column flex-column-fluid ${classes.kt_content} ${
                window.location.pathname === '/manage/account' ? 'dtStep3' : ''
              } ${
                window.location.pathname === '/manage/teams' ? 'dtStep4' : ''
              } ${
                window.location.pathname === '/manage/agents' ? 'dtStep5' : ''
              } ${
                window.location.pathname === '/manage/numbers/unblocked'
                  ? 'dtStep6'
                  : ''
              } ${
                window.location.pathname === '/manage/queues' ? 'dtStep8' : ''
              } ${
                window.location.pathname === '/call-reporting/queues'
                  ? 'dtStep9'
                  : ''
              }`}
              // style={{ padding: ignorePadding ? '0px' : '25px' }}
            >
              {layoutProps.subheaderDisplay && <SubHeader />}
              {/* begin::Entry */}
              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  {/* begin::Container */}
                  <div
                    // style={{ paddingTop: ignorePadding ? '0px' : '25px' }}
                    className={layoutProps.contentContainerClasses}
                  >
                    {children}
                  </div>
                  {/* end::Container */}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
              {/* end::Entry */}
            </div>
            {/* end::Content */}
            {/* <Footer /> */}
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Page */}
      </div>
      <QuickUser />
      <HelpSidebar />
      <QuickPanel />
      <ScrollTop />
      {/* <StickyToolbar /> */}
      {/* end::Main */}
      <LayoutInit />
    </>
  ) : (
    // BLANK LAYOUT
    <div className={`d-flex flex-column flex-root ${classes.root}`}>
      {children}
    </div>
  );
}
